import { Loading } from 'glints-aries';
import styled from 'styled-components';

export const StyledLoading = styled(Loading)`
  width: 100%;
  margin: 0 15px;
`;
